export const SUBSCRIPTION_STATUS = {
  UNPAID: "unpaid",
  IN_ACTIVE: "in_active",
  ACTIVE: "active",
  TRIAL: "trialing",
};

export const USER_ROLES = {
  ADMIN: "admin",
  USER: "kortex_user",
  SUPERADMIN: "superadmin",
  STAFFADMIN: "staffadmin",
};

export const NOTE: any = {
  name: "Name",
  age: "Age",
  sex: "Sex",
  gender: "Gender",
  updates: "Updates",
  consults: "Consults",
  snippets: "Snippets",
  allergies: "Allergies",
  condition: "Condition",
  assessment: "Assessment",
  icd10_code: "icd10 code",
  procedures: "Procedures",
  diagnostics: "Diagnostics",
  disposition: "Disposition",
  medications: "Medications",
  critical_care: "Critical Care",
  physical_exam: "Physical Exam",
  family_history: "Family History",
  social_history: "Social History",
  chief_complaint: "Chief Complaint",
  review_of_systems: "Review of Systems",
  past_medical_history: "Past Medical History",
  differential_diagnosis: "Differential Diagnosis",
  history_present_illness: "History of Present Illness",
  medical_decision_making: "Medical Decision Making",
  type: "Type",
  details: "Details",
  note: "Note",
  scratchpad: "Scratchpad",
  admission_status: "Admission Status",
  medical_note: "Medical Note",
  room_num: "Room Number",
  comments: "Comments",
  additional_note: "Additional Note",
  description: "Description",
  title: "Title",
  content: "Content",
};

export const CATEGORY_FIELDS: any = {
  history_present_illness: {
    text: "History of Present Illness",
    fields: [
      "chief_complaint",
      "history_present_illness",
      "past_medical_history",
      "social_history",
      "family_history",
    ],
  },
  review_of_systems: {
    text: "Review of Systems",
    fields: ["review_of_systems", "medications", "allergies"],
  },
  physical_exam: {
    text: "Physical Exam",
    fields: ["physical_exam", "diagnostics", "assessment"],
  },
  differential_diagnosis: {
    text: "Differential Diagnosis",
    fields: ["differential_diagnosis", "condition", "icd10_code"],
  },
  medical_decision_making: {
    text: "Medical Decision Making",
    fields: ["medical_decision_making", "assessment", "diagnostics"],
  },
  consults: {
    text: "Consults",
    fields: ["consults", "snippets"],
  },
  procedures: {
    text: "Procedures",
    fields: ["procedures", "assessment", "snippets"],
  },
  critical_care_note: {
    text: "Critical Care Note",
    fields: [
      "critical_care",
      "assessment",
      "medical_decision_making",
      "diagnostics",
    ],
  },
  disposition: {
    text: "Disposition",
    fields: ["disposition", "medications", "assessment", "condition"],
  },
};

export const DEFAULT_FIELDS: any = {
  chief_complaint: "",
  history_present_illness: "",
  physical_exam: "",
  medical_decision_making: "",
  review_of_systems: "",
  past_medical_history: "",
  social_history: "",
  family_history: "",
  medications: "",
  allergies: "",
  diagnostics: "",
  differential_diagnosis: "",
  consults: "",
  procedures: [],
  critical_care: {},
  snippets: [],
  assessment: "",
  icd10_code: "",
  condition: "",
  disposition: {},
};

export const MEDICAL_VARIABLES: any = {
  content: [
    "patient",
    "datetime",
    "chief_complaint",
    "history_present_illness",
    "physical_exam",
    "medical_decision_making",
    "review_of_systems",
    "past_medical_history",
    "social_history",
    "family_history",
    "medications",
    "allergies",
    "diagnostics",
    "differential_diagnosis",
    "consults",
    "procedures",
    "critical_care",
    "assessment",
    "icd10_code",
    "condition",
    "disposition",
    "updates",
  ],
  patient: ["name", "age", "gender", "dob", "mrn"],
  datetime: [
    "current_date",
    "current_time",
    "admission_date",
    "discharge_date",
  ],
  chief_complaint: [
    "onset_duration",
    "pain_severity",
    "symptoms_location",
    "symptoms_character",
  ],
  history_present_illness: [
    "symptom_onset",
    "symptom_duration",
    "symptom_severity",
    "symptom_progression",
    "associated_symptoms",
    "alleviating_factors",
    "aggravating_factors",
  ],
  physical_exam: [
    "vitals_bp",
    "vitals_hr",
    "vitals_rr",
    "vitals_temp",
    "vitals_o2sat",
    "exam_general",
    "exam_heent",
    "exam_cardiac",
    "exam_pulmonary",
    "exam_abdominal",
    "exam_extremities",
    "exam_neuro",
  ],
  medical_decision_making: [
    "risk_level",
    "complexity_level",
    "data_reviewed",
    "decision_rationale",
  ],
  review_of_systems: [
    "ros_constitutional",
    "ros_cardiovascular",
    "ros_respiratory",
    "ros_gi",
    "ros_musculoskeletal",
    "ros_neurological",
  ],
  past_medical_history: [
    "pmh_conditions",
    "pmh_surgeries",
    "pmh_hospitalizations",
    "pmh_immunizations",
  ],
  social_history: [
    "social_occupation",
    "social_tobacco",
    "social_alcohol",
    "social_drugs",
    "social_living",
  ],
  family_history: ["fh_cardiovascular", "fh_cancer", "fh_diabetes", "fh_other"],
  medications: [
    "med_name",
    "med_dose",
    "med_frequency",
    "med_route",
    "med_start_date",
  ],
  allergies: ["allergy_agent", "allergy_reaction", "allergy_severity"],
  diagnostics: [
    "lab_cbc",
    "lab_cmp",
    "imaging_xray",
    "imaging_ct",
    "imaging_mri",
    "test_results",
  ],
  differential_diagnosis: [
    "ddx_primary",
    "ddx_secondary",
    "ddx_working",
    "ddx_ruled_out",
  ],
  consults: ["consult_specialty", "consult_reason", "consult_recommendation"],
  procedures: [
    "procedure_name",
    "procedure_indication",
    "procedure_technique",
    "procedure_findings",
    "procedure_complications",
  ],
  critical_care: [
    "cc_time_spent",
    "cc_interventions",
    "cc_monitoring",
    "cc_response",
  ],
  assessment: [
    "assessment_primary",
    "assessment_secondary",
    "assessment_progress",
    "assessment_status",
  ],
  icd10_code: ["icd_primary", "icd_secondary", "icd_additional"],
  condition: ["condition_status", "condition_severity", "condition_stage"],
  disposition: [
    "disposition_type",
    "disposition_level",
    "disposition_followup",
    "disposition_instructions",
  ],
  snippets: [
    "snippet_normal_exam",
    "snippet_normal_vitals",
    "snippet_normal_neuro",
    "snippet_followup_instructions",
  ],
};

interface NoteType {
  [key: string]: string;
}

export const NoteTypes: NoteType = {
  id: "string",
  mrn: "string",
  fin: "string",
  first_name: "string",
  last_name: "string",
  date_of_birth: "string",
  room_num: "string",
  chief_complaint: "string",
  text_instruction: "string",
  comments: "string",
  scratchpad: "string",
  additional_note: "string",
  age: "string",
  sex: "string",
  gender: "string",
  history_present_illness: "string",
  review_of_systems: "string",
  past_medical_history: "string",
  social_history: "string",
  family_history: "string",
  medications: "string",
  allergies: "string",
  physical_exam: "string",
  diagnostics: "string",
  differential_diagnosis: "string",
  medical_decision_making: "string",
  consults: "string",
  procedures: "array",
  name: "string",
  details: "string",
  template: "string",
  critical_care: "object",
  snippets: "array",
  assessment: "string",
  icd10_code: "string",
  condition: "string",
  disposition: "object",
  type: "string",
  admission_status: "string",
  updates: "array",
};
